const isDev =
  typeof process !== "undefined" &&
  process.env.REACT_APP_ENVIORNMENT === "development"

const STORAGE_KEY = "smash_logger_debug"

const readStoredFlag = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

let isProdDebugActive = readStoredFlag()

const shouldLog = () => isDev || isProdDebugActive

const persistFlag = (value) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(value))
  } catch {}
}

export const logger = {
  log: (...args) => {
    if (shouldLog()) {
      console.log(...args)
    }
  },
  warn: (...args) => {
    if (shouldLog()) {
      console.warn(...args)
    }
  },
  error: (...args) => {
    if (shouldLog()) {
      console.error(...args)
    }
  },
  enable: () => {
    isProdDebugActive = true
    persistFlag(true)
    console.log(
      "%c[LOGGER] Production logs ENABLED for this session.",
      "color: #00bcd4; font-weight: bold;"
    )
  },
  disable: () => {
    isProdDebugActive = false
    persistFlag(false)
    console.log(
      "%c[LOGGER] Production logs DISABLED.",
      "color: #ff5722; font-weight: bold;"
    )
  },
}

if (typeof window !== "undefined" && !isDev) {
  window.appLogger = logger
}
